//import all neccessary components
import React from 'react'
import { withRouter } from 'react-router-dom'
import { Component } from 'react'
import Modal from 'react-modal'
import TxnsLoanBalanceModalUI from './TxnsLoanBalanceModalUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class TxnsLoanBalanceModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: [],
            submitted: false,

            loanBalanceF: '',
            loanBalanceFError: null,
            dsraCurrentF: '',
            dsraCurrentFError: null,
            dsraTotalF: '',
            dsraTotalFError: null,
            details: '',
            detailsError: null,
        }
    }

    render() {
        return (
            <TxnsLoanBalanceModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                selectedTxnId={this.props.selectedTxnId}
                updateLoanBalanceMode={this.props.updateLoanBalanceMode}
                //loanBalance
                loanBalanceF={this.state.loanBalanceF}
                onLoanBalanceFChange={(event) => { this.setState({ loanBalanceF: event.target.value }) }}
                loanBalanceFError={this.state.loanBalanceFError}
                setLoanBalanceFError={(error) => { this.setState({ loanBalanceFError: error }) }}
                //dsraCurrent
                dsraCurrentF={this.state.dsraCurrentF}
                onDsraCurrentFChange={(event) => { this.setState({ dsraCurrentF: event.target.value }) }}
                dsraCurrentFError={this.state.dsraCurrentFError}
                setDsraCurrentFError={(error) => { this.setState({ dsraCurrentFError: error }) }}
                //dsraTotal
                dsraTotalF={this.state.dsraTotalF}
                onDsraTotalFChange={(event) => { this.setState({ dsraTotalF: event.target.value }) }}
                dsraTotalFError={this.state.dsraTotalFError}
                setDsraTotalFError={(error) => { this.setState({ dsraTotalFError: error }) }}
                //details
                details={this.state.details}
                onDetailsChange={(event) => { this.setState({ details: event.target.value }) }}
                detailsError={this.state.detailsError}
                setDetailsError={(error) => { this.setState({ detailsError: error }) }}

                onSubmit={this.onSubmit}
                submitted={this.state.submitted}
                onLoanBalanceCancelClick={this.onLoanBalanceCancelClick}
                onRefreshClick={this.onRefreshClick}
                setErrorList={this.setErrorList}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
    }

    onSubmit = () => {
        let submitted = this.state.submitted
        if (submitted)
            return

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        RestApiUtils.put(this.props.context,
            `/api/su/transactions/${this.props.selectedTxnId}/loanBalances`,
            this.onSubmitCallback, {
            loanBalanceF: this.state.loanBalanceF,
            dsraCurrentF: this.state.dsraCurrentF,
            dsraTotalF: this.state.dsraTotalF,
            details: this.state.details
        })
    }

    onSubmitCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
          errorList.push(error.message)
        })
    
        this.setState({
          successMsg: response.success,
          errorList: errorList,
          submitted: false
        })
    
        if (response.errorList.length === 0) {
          setTimeout(() => {
            this.setState({
              successMsg: null
            })
            this.onLoanBalanceCancelClick()
            this.props.onRefreshClick()
          }, 1000)
        }
      }
    

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
        if (errorList && errorList.length > 0)
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }

    onLoanBalanceCancelClick = () => {
        // reset everything
        this.setState({
            successMsg: null,
            errorList: null,
            loanBalanceF: '',
            loanBalanceFError: null,
            dsraCurrentF: '',
            dsraCurrentFError: null,
            dsraTotalF: '',
            dsraTotalFError: null,
            details: '',
            detailsError: null,
            submitted: false
        })

        this.props.onLoanBalanceCancelClick()
    }

}

export default TxnsLoanBalanceModalSF
